import { Categorie } from "../../../../types/features/Post";
import TableRow from "../../../ui/TableRow";

interface CategorieRowProps {
  categorie: Categorie;
  onAction: (categorie: Categorie) => void;
  onSelect?: (categorie: Categorie, isSelected: boolean) => void;
  isSelected?: boolean;
  selectable?: boolean;
}

export default function CategorieRow({
  categorie,
  onAction,
  onSelect,
  isSelected = false,
  selectable = false,
}: CategorieRowProps) {
  return (
    <TableRow
      item={categorie}
      onAction={onAction}
      onSelect={onSelect}
      isSelected={isSelected}
      selectable={selectable}
      actionable={true}
    >
      <td className="py-3 px-4">
        <div>
          <span className="font-medium text-gray-800 block">{categorie.name}</span>
          <span className="text-xs text-gray-500">slug: {categorie.slug}</span>
        </div>
      </td>

      <td className="hidden sm:table-cell py-3 px-4">
        <span className="text-gray-600">{categorie.name_en || "-"}</span>
      </td>

      <td className="hidden md:table-cell py-3 px-4">
        <span className="text-gray-500 text-sm line-clamp-1">{categorie.description || "-"}</span>
      </td>

      <td className="hidden lg:table-cell py-3 px-4 text-center">
        <span className="inline-flex items-center justify-center px-2 py-1 text-xs font-medium rounded-full bg-gray-100 text-gray-700">
          {categorie.post_count || 0} article(s)
        </span>
      </td>
    </TableRow>
  );
}
